const state = {
    images: [],
    error: null,
    urlUpload: ""
};

export default state;
